<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="cancelOrderModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('customer.cancelOrderTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeCancelingOrderModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="cancelAlert"
              >
                {{ $t('adminCancelOrder.orderCanceledSuccessfully') }}
              </v-alert>
              <v-alert
                type="warning"
                :value="willAutoRefund"
                style="margin-bottom:12px;"
              >
                {{ $t('adminCancelOrder.willAutoRefundPrefix') }}<span v-if="refundAmount">{{ $t('adminCancelOrder.ofUpToAmount', { amount: refundAmount }) }}</span>{{ $t('adminCancelOrder.willAutoRefundTail') }}
              </v-alert>
              <v-layout wrap>
                <v-flex
                  xs12
                >
                  <v-select
                    :items="reasons"
                    item-value="value"
                    item-text="text"
                    :label="$t('adminCancelOrder.cancelReasonListLabel') + '*'"
                    v-model="selectedReason"
                    data-vv-name="Cancel reason"
                    @input="updateReasons"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    :label="$t('adminCancelOrder.cancelReasonEnglishLabel') + '*'"
                    v-model="cancelData.cancel_reason"
                    :error-messages="errors.collect('Cancel reason')"
                    v-validate="'required'"
                    data-vv-name="Cancel reason"
                  ></v-text-field>
                </v-flex>
                </v-layout>
                <v-layout>
                <v-flex>
                  <v-text-field
                    :label="$t('adminCancelOrder.cancelReasonArabicLabel') + '*'"
                    v-model="cancelData.cancel_reason_ar"
                    :error-messages="errors.collect('Cancel reason arabic')"
                    v-validate="'required'"
                    data-vv-name="Cancel reason arabic"
                  ></v-text-field>
                </v-flex>
                </v-layout>
                <v-layout>
                <v-flex>
                  <v-text-field
                    :label="$t('adminCancelOrder.cancelReasonKurdishLabel') + '*'"
                    v-model="cancelData.cancel_reason_ku"
                    :error-messages="errors.collect('Cancel reason kurdish')"
                    v-validate="'required'"
                    data-vv-name="Cancel reason kurdish"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeCancelingOrderModal(), $validator.reset()"
                outline
                color="normal"
              >{{ $t('common.close') }}</v-btn>
              <v-btn
                type="submit"
                style="height:auto" class="rtl-mr-4pct"
                outline
                color="success"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    cancelOrderModal: {},
    closeCancelingOrderModal: {},
    cancelAlert: {},
    cancelData: {},
    cancelingOrder: {},
    reasons: {},
    willAutoRefund: {
      type: Boolean,
      default: false
    },
    refundAmount: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      selectedReason: null
    }
  },

  watch: {
    cancelOrderModal(newVal) {
      if (!newVal) {
        this.selectedReason = null
      }
    }
  },

  methods: {
    updateReasons() {
      if (this.selectedReason) {
        // Find the selected reason object with all translations
        const reasonObj = this.reasons.find(r => r.value === this.selectedReason)
        if (reasonObj) {
          // Add a short timeout to ensure Vue has updated the model
          setTimeout(() => {
            this.cancelData.cancel_reason = reasonObj.value
            this.cancelData.cancel_reason_ar = reasonObj.ar
            this.cancelData.cancel_reason_ku = reasonObj.ku
          }, 0)
        }
      }
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.cancelingOrder()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/adminCancelOrder.vue